import React from 'react';
import { 
    Box, 
    TextField, 
    Typography, 
    Paper,
    Button 
} from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useTheme } from '@mui/material/styles';





const BusinessContext = ({ onSubmit }) => {
    const theme = useTheme();
    const [context, setContext] = React.useState({
        businessName: '',
        solution: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        onSubmit(context);
    };
    const sampleData = {
        businessName: "BetterWhiteBoardPens",
        solution: "Bluetooth Enabled Whiteboard Pens"
    };
    
    

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <Paper sx={{ p: 3, mb: 3 }}>
              
           

            <TextField
                fullWidth
                label="Business/Brand Name"
                value={context.businessName}
                onChange={(e) => setContext({...context, businessName: e.target.value})}
                placeholder="Example: Fresh Eats Delivery"
                required
                sx={{
                    mb: theme.spacing(2),
                    '& .MuiOutlinedInput-root': {
                      borderColor: theme.palette.primary.main
                    }
                  }}
            />

            <TextField
                fullWidth
                label="Your Solution/Product"
                value={context.solution}
                onChange={(e) => setContext({...context, solution: e.target.value})}
                placeholder="Example: Mobile app for healthy meal delivery"
                required
                sx={{
                    mb: theme.spacing(2),
                    '& .MuiOutlinedInput-root': {
                      borderColor: theme.palette.primary.main
                    }
                  }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                    variant="outlined" 
                    onClick={() => setContext(sampleData)}
                    startIcon={<AutoFixHighIcon />}
                    sx={{
                        mb: theme.spacing(2),
                        '& .MuiOutlinedInput-root': {
                          borderColor: theme.palette.primary.main
                        }
                      }}
                >
                    Load Sample Data
                </Button>
                <Button 
                    type="submit" 
                    variant="contained"
                    disabled={!context.businessName || !context.solution}
                >
                    Next
                </Button>
            </Box>
            </Paper>
        </Box>
    );
};

export default BusinessContext;


